module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "aboutAuthorPage",
    attrs: {
      "id": "ata"
    }
  }, [_c('h2', {
    staticClass: "aboutAuthorHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JANET DEAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_vm._v("grew up in a family that cherished the past and had a strong creative streak. Her father recounted wonderful stories, like his father before him. The tales they told instilled in Janet a love of history and the desire to write. She married her college sweetheart and taught first grade before leaving to rear two daughters. As her daughters grew, they watched "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Little House on the Prairie,")]), _vm._v(" reawakening Janet’s love of American history and the stories of strong men and women of faith who built this country. Janet eagerly turned to inspirational historical romance, and she loves spinning stories for Steeple Hill Love Inspired Historical. When she isn’t writing, Janet stamps greeting cards, plays golf and bridge, and is never without a book to read. The Deans love to travel and to spend time with family.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95624452","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_ata.vue
// module id = 63
// module chunks = 0